(ns ^:dev/always bp-clients.tv-app.api.graphql.title
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/title/detail.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private detail-raw (get-in query-map [:query :tv-app-title-detail-page]))

(defn by-slug
  "Query a title detail page by its slug"
  [slug]
  (query-builder detail-raw {:slug (name slug)}))

(comment
  ;; see the corresponding .graphql files for more impormation
  (by-slug "entre-lobos")

  nil)
